// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';

// img
import singleDownloadImg from '../img/download_img.png';

function Gaap03Velvet(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title"><em>De novo</em> assembly </h2>
            <h2 className="content_title2">Genome assembly</h2>
            <div className="content_command_title">Velvet</div><br/>
            <div className="content_text">
                Velvet takes in short read sequences, 
                removes errors then produces unique contigs.
            </div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="http://www.ebi.ac.uk/~zerbino/velvet" />
                    <br/>
                </div>
            </div><br/>
            <li className="content_description">Velvet command</li>
            <div className="content_text">
                The assembly process of velvet consists of two stages: 
                first, velveth takes in a number of read files, produces 
                a hash index file, then outputs two files (Sequences and Roadmaps) 
                in the output directory, which are necessary to the following program. Next, the core program, velvetg, builds and manipulates de Bruijn graphs for genomic sequence assembly.
            </div><br/>
            <ol>
                <li className="content_description">Velveth command</li>
                <CommandBox lines={[
                    {data:
                        `velveth output_directory/ hash_length -fastq -shortPaired DNAread170_1.fastq DNAread170_2.fastq 
                        -shortPaired2 DNAread400_1.fastq DNAread400_2.fastq -longPaired DNAread2900_1.fastq DNAread2900_2.fastq`
                    },
                ]}
                /><br/>
                <OptionTable
                data={[
                    {   option:'hash_length',
                        desc:'specify the length of the words being hashed'},
                    {   option:'-fastq',
                        desc:'specify the format of the read data'},
                    {   
                        option:`-shortPaired \n -shortPaired2`,
                        desc:'specify the file name of library with short insert size'},
                    {   option:'-longPaired',
                        desc:'specify the file name of library with long insert size'},    
                ]}
                /><br />
                <li className="content_description">Velvetg command</li>
                <CommandBox lines={[
                    {data:
                        `velvetg output_directory/ -cov_cutoff auto -exp_cov auto -ins_length 170 
                        -ins_length2 400 -ins_length_long 2900 -scaffolding yes`
                    },
                ]}
                /><br/>
                <OptionTable
                data={[
                    {   option:'-cov_cutoff',
                        desc:'specify the coverage cutoff value'},
                    {   option:'-exp_cov',
                        desc:'specify the expected short-read k-mer coverage value'},
                    {   option:`-ins_length \n -ins_length2`,
                        desc:'specify the expected short insert length of the paired-end reads'},
                    {   option:'-ins_length_long',
                        desc:'specify the expected long insert length of the paired-end reads'}, 
                    {   option:'-scaffolding',
                        desc:'specify whether to scaffold contigs'},    
                ]}
                /><br />
            </ol>
            <li className="content_description">Output of Velvet</li>
            <div className="content_text">
                Velvet produces a fasta file which contains the sequences of 
                contig and scaffold, and outputs some statistics. 
            </div><br/>
            <div className="content_buttons_div">
                <Link to="/Gaap03_Abyss"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap03_Gap"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap03Velvet;